import { List } from "immutable"

export const htmlDecode = (input: any) => {
  input = input || ''
  try {
    var doc = new DOMParser().parseFromString(input, 'text/html')
    return doc.documentElement.textContent
  } catch (e) {
    console.error(e)
    return input
  }
}

export const unEntity = (str: string) => {
  str = str || ''
  return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
}

let prevUrl = ""
let prevUrlFull = ""
let runningScrollToTop = false
export const scrollToTop = (retryAttempt: number = 0,) => {
  if (runningScrollToTop) return
  runningScrollToTop = true
  setInterval(() => {
    let addressFull = window.location.href
    let addressNoHash = addressFull.split("#")[0]
    if (prevUrl == "" || addressFull.includes("#")) {
      prevUrl = addressNoHash
      prevUrlFull = addressFull
      return
    }

    if (prevUrlFull != addressFull) {
      prevUrl = addressNoHash
      prevUrlFull = addressFull
      setTimeout(() => {

        window.scrollTo(0, -50);
      }, 100);
      return
    }
  }, 500)
}

let runningScrollToHash = false
let currentGlobalHash = ""
export const scrollToHash = (hash = window.location.hash, interval = 100) => {
  if (runningScrollToHash) return
  runningScrollToHash = true
  const currentInterval = setInterval(() => {    
    if (hash == currentGlobalHash) {
      clearInterval(currentInterval)
      currentGlobalHash = ""
      runningScrollToHash = false
      return
    }

    if (hash != '' && hash != undefined) {
      currentGlobalHash = hash
      let q = document.querySelector(`[id*=${hash.substring(1)}]`)
      let element: HTMLElement = q !== null ? q : (null as any)

      if (element == null) {
        currentGlobalHash = ""
        return
      }

      if (element !== null) {
        setTimeout(() => {
          element.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          })
          runningScrollToHash = false
        }, interval);
      }
    }
  }, interval)
}

export let updateItemInPosition = <T>(l : List<T>, index : number, u : (i:T) => T) => {
  return l.map((e,i) => {
    if(i != index) return e
    return u(e)
  })
}

export const fixTableStructure = (text: string) => {
  // Add a container around a table inside a WYSIWYG editor, needed for responive version
  const replacedtext = text.replace(/<table>/g, '<div class="table--wyswiyg"><table>').replace(/<\/table>/g, '</table></div>');
  return replacedtext;
}

export const convertTitleForBackground = (title: string) => {
  let titleWords:string[] = title.split(' ');

  titleWords = titleWords.map((v, k) => {
    return `<span aria-hidden="true"><span>${v}</span></span>`;
  })
  
  return `<span class="sr-text">${title}</span>${titleWords.join('')}</div>`;
}
